import React from 'react';
import './styles.scss';

import { ReactComponent as PenIcon } from '@assets/images/penicon.svg';

interface EditStepBtnProps {
  title: string;
  onClick: () => void;
}

export const EditStepBtn = ({ title, onClick }: EditStepBtnProps) => {
  return (
    <button className="checkout__edit-btn" onClick={onClick}>
      <span>
        <PenIcon />
      </span>
      {title}
    </button>
  );
};
